import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import FinalLeaderboardComponent from './js/final-leaderboard.component';

ComponentsFactory.getInstance().define('final-leaderboard', FinalLeaderboardComponent);
